import React from "react";
import ProdutoModel from "./model/ProdutoModel";
import MockData from "./model/MockData";
import GrupoProdutos from "./components/GrupoProdutos";
import Rodape from "./components/Rodape";
import BuscaProdutos from "./components/BuscaProdutos";
import CategoriaModel from "./model/CategoriaModel";
import Slider from "react-slick";
import { ConfiguracoesCarrosselCategoriaVW } from "./components/ConfiguracoesCarrosselPadrao";
import QueryString from "query-string";
import SeletorLoja from "./components/SeletorLoja";
import AppState from "./model/AppState";
import PaginaTitulo from "./components/PaginaTitulo";
import C5CategoriaDAO from "./dataAccess/C5/C5CategoriaDAO";
import LojaModel from "./model/LojaModel";
import LogUtil from "./util/LogUtil";
import Carregando from "./components/Carregando";
import NavegadorUtil from "./util/NavegadorUtil";
import { RouteComponentProps, Link, withRouter } from "react-router-dom";

interface ICategoriaProps extends RouteComponentProps {}

type CategoriaState = {
  nome: string;
  subcategorias: CategoriaModel[];
  carregando: boolean;
  carregandoTotal: number;
  concluido: boolean;
  catId: string;
  subcatId: string;
  link: String;
};

class Categoria extends React.Component<ICategoriaProps, CategoriaState> {
  constructor(props: ICategoriaProps) {
    super(props);

    this.loadCategorias = this.loadCategorias.bind(this);

    this.state = {
      nome: "",
      subcategorias: [],
      carregando: false,
      carregandoTotal: 0,
      concluido: false,
      catId: "",
      subcatId: "",
      link: '',
    };
  }

  componentDidMount(): any {
    LogUtil.logPage("Categoria");
    this.loadCategorias();
  }

  loadCategorias(): void {
    let allProms: any = [];

    console.log('loadCategorias();');
    if (AppState.getMockData()) {
      let query: any;
      query = QueryString.parse(this.props.location.search);
      const categoria: CategoriaModel = MockData.getCategoria(query.catId);
      categoria.subcategorias = MockData.getCategorias();

      this.setState({
        nome: categoria.nome,
        subcategorias: categoria.subcategorias,
      });
    
    } else {
      let search = this.props.location.search;
      let query: any;
      query = QueryString.parse(search);

      const loja: LojaModel | null = AppState.getLojaSelecionada();
      if (loja) {
        if (query.subcatId) {
          // this.setState({
          //   carregando: true,
          //   subcatId: query.subcatId,
          //   catId: query.catId,
          // });

          allProms.push(
            C5CategoriaDAO.getInstance()
              .getTerceiroNivel(query.catId, query.subcatId)
              .then((subcats: CategoriaModel[]) => {
                this.setState({
                  nome: query.nome,
                  subcategorias: subcats,
                  carregando: true,
                  subcatId: query.subcatId,
                  catId: query.catId,
                });
                const subProms: any = [];

                for (const subcat of subcats) {
                  subProms.push(
                    C5CategoriaDAO.getInstance()
                      .getTerceiroNivelProdutos(
                        query.catId,
                        subcat.segundoNivelId,
                        subcat.terceiroNivelId,
                        loja.lojaId
                      )
                      .then((prods: ProdutoModel[]) => {
                        subcat.produtos = prods;
                        this.setState({
                          subcategorias: subcats,
                          carregandoTotal: this.state.carregandoTotal+1
                        });
                      })
                  );
                }
                Promise.all(subProms).then(() => {
                  this.setState({ carregando: false, concluido: true, link: search });
                });
              })
          );
        } else {
          if (query.catId) {
            allProms.push(
              C5CategoriaDAO.getInstance()
                .getSegundoNivel(query.catId)
                .then((subcats: CategoriaModel[]) => {
                  const subProms: any = [];

                  this.setState({
                    nome: query.nome,
                    subcategorias: subcats,
                    carregando: true,
                    catId: query.catId,
                  });

                  for (const subcat of subcats) {
                    subProms.push(
                      C5CategoriaDAO.getInstance()
                        .getSegundoNivelProdutos(
                          query.catId,
                          subcat.segundoNivelId,
                          loja.lojaId,
                          5
                        )
                        .then((prods: ProdutoModel[]) => {
                          subcat.produtos = prods;
                          this.setState({
                            subcategorias: subcats,
                            carregandoTotal: this.state.carregandoTotal+1,
                          });
                        })
                    );
                  }
                  Promise.all(subProms).then(() => {
                    this.setState({ carregando: false, concluido: true, link: search });
                  });
                })
            );
          }
        }
      } else {
        NavegadorUtil.redirect("/lojas", this.props.history);
      }
    }
  }

  getLink(cat: CategoriaModel): string {
    let query: any;
    query = QueryString.parse(this.props.location.search);
    if (cat.terceiroNivelId) {
      return NavegadorUtil.getUrl(
        `/categoria-interna?catId=${query.catId}&subcatId=${cat.segundoNivelId}` +
          `&subsubcatId=${cat.terceiroNivelId}&nome=${cat.nome}&sub=${query.sub} - ${query.nome}`
      );
    } else {
      return NavegadorUtil.getUrl(
        `/categoria?catId=${cat.categoriaId}&subcatId=${cat.segundoNivelId}&nome=${cat.nome}&sub=${query.nome}`
      );
    }
  }

  render(): any {
    const { carregando, concluido, link } = this.state;

    let _link: string = this.props.location.search;
    if ( concluido && !carregando && link !== _link )
      this.loadCategorias();

    return (
      <section className="category has-footer white-bg">
        <SeletorLoja loja={AppState.getLojaSelecionada()}></SeletorLoja>
        <BuscaProdutos parent={this}></BuscaProdutos>
        {this.state.nome && (
          <PaginaTitulo titulo={this.state.nome}></PaginaTitulo>
        )}
        <Slider
          {...ConfiguracoesCarrosselCategoriaVW}
          className="subcategories"
        >
          {Array.isArray(this.state.subcategorias) &&
            this.state.subcategorias.map((subcat: CategoriaModel) => (
              <div
                className="item"
                key={`${subcat.categoriaId}-${subcat.segundoNivelId}-${subcat.terceiroNivelId}`}
              >
                <Link to={this.getLink(subcat)}>{subcat.nome}</Link>
              </div>
            ))}
        </Slider>
        {Array.isArray(this.state.subcategorias) &&
          this.state.subcategorias.map((subcat: CategoriaModel) => {
            if (subcat.produtos && subcat.produtos.length > 0) {
              return (
                <GrupoProdutos
                  key={`${subcat.categoriaId}-${subcat.segundoNivelId}-${subcat.terceiroNivelId}`}
                  titulo={subcat.nome}
                  items={subcat.produtos}
                  linkMais={this.getLink(subcat)}
                  parent={this}
                ></GrupoProdutos>
              );
            } else {
              return null;
            }
          })}
        <Rodape parent={this} ativo=""></Rodape>
        <Carregando exibir={carregando} concluido={concluido} />
      </section>
    );
  }
}

export default withRouter(Categoria);
